import { BrowserModule }   from '@angular/platform-browser';
import { NgModule }        from '@angular/core';
import { FormsModule }    from '@angular/forms';
import { RouterModule, Routes }   from '@angular/router';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireAuth } from 'angularfire2/auth';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs/Observable';
import * as firebase from 'firebase/app';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { SimpleNotificationsModule } from "angular2-notifications";
import { AppRoutingModule }    from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

import { FileSizePipe } from './file-size.pipe';
import { TruncatePipe } from "./collections.pipe";

import { FirebaseService } from './services/firebase.service';
import { IngredientService } from './services/ingredient.service';
import { CategoryService } from './services/category.service';
import { FirebaseStorageService } from './services/firebase-storage.service';
import { TonalityService } from './services/tonality.service';
import { ColorShadeService } from './services/color-shade.service';
import { PigmentService } from './services/pigment.service';
import { UserService } from "./services/user.service";
import { NewsService } from "./services/news.service";
import { CompanyService } from "./services/company.service";
import { DocumentService } from "./services/document.service";
import { ImageService } from "./services/image.service";
import { QuotationHistoryService } from "./services/quotation-history.service";
import { PaginationService } from "./services/pagination.service";
import { NotificationsService } from "angular2-notifications";
import { HomeService } from "./services/home.service";

import { AuthGuard } from './_guards/auth.guard';

import { AppComponent }    from './app.component';
import { HomeComponent } from './components/home/home.component';
import { SidebarMenuComponent } from './components/sidebar-menu/sidebar-menu.component';
import { MainHeaderComponent } from './components/main-header/main-header.component';
import { LoginPageComponent } from './components/login-page/login-page.component';
import { IngredientsComponent } from './components/ingredient/ingredients/ingredients.component';
import { IngredientComponent } from './components/ingredient/ingredient/ingredient.component';
import { AdminComponent } from './components/admin/admin.component';
import { CategoriesComponent } from './components/category/categories/categories.component';
import { MediaSelectorComponent } from './components/media-selector/media-selector.component';
import { TonalitiesComponent } from './components/tonality/tonalities/tonalities.component';
import { ColorShadeComponent } from './components/color-shade/color-shade/color-shade.component';
import { PigmentComponent } from './components/pigment/pigment/pigment.component';
import { IngredientAddEdit } from './components/ingredient/ingredient-add-edit.component';
import { UsersComponent } from "./components/user/users/users.component";
import { UserAddEditComponent } from './components/user/user-add-edit/user-add-edit.component';
import { NewsComponent } from './components/news/news/news.component';
import { NewsAddEditComponent } from './components/news/news-add-edit/news-add-edit.component';
import { CompaniesComponent } from './components/company/companies/companies.component';
import { CompaniesAddEditComponent } from './components/company/companies-add-edit/companies-add-edit.component';
import { ImageComponent } from './components/media/image/image.component';
import { DocumentComponent } from './components/media/document/document/document.component';
import { DocumentSelectorComponent } from './components/media/document/document-selector/document-selector.component';
import { AddEditCategoryComponent } from "./components/category/add-edit-category.component";
import { CompaniesBulkComponent } from './components/company/companies-bulk/companies-bulk.component';
import { QuotationHistoryComponent } from './components/quotation/quotation-history/quotation-history.component';
import { QuotationHistoryListComponent } from './components/quotation/quotation-history-list/quotation-history-list.component';
import { QuotationHistorySingleComponent } from './components/quotation/quotation-history-single/quotation-history-single.component';

import { IngredientsBulkComponent } from './components/ingredient/ingredients-bulk/ingredients-bulk.component';

import { SelectModule } from 'ng2-select';
import { AdminlistComponent } from './components/adminlist/adminlist/adminlist.component';
import { AdminlistAddEditComponent } from './components/adminlist/adminlist-add-edit/adminlist-add-edit.component';

import { RecaptchaModule } from 'ng-recaptcha';
import { IngredientsExportComponent } from './components/ingredient/ingredients-export/ingredients-export.component';
import { PointReplacerPipe } from './point-replacer.pipe';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    SidebarMenuComponent,
    MainHeaderComponent,
    LoginPageComponent,
    IngredientsComponent,
    IngredientComponent,
    AdminComponent,
    CategoriesComponent,
    MediaSelectorComponent,
    FileSizePipe,
    TonalitiesComponent,
    ColorShadeComponent,
    PigmentComponent,
    IngredientAddEdit,
    UsersComponent,
    UserAddEditComponent,
    IngredientAddEdit,
    NewsComponent,
    NewsAddEditComponent,
    TruncatePipe,
    CompaniesComponent,
    CompaniesAddEditComponent,
    ImageComponent,
    DocumentComponent,
    DocumentSelectorComponent,
    AddEditCategoryComponent,
    CompaniesBulkComponent,
    QuotationHistoryComponent,
    QuotationHistoryListComponent,
    QuotationHistorySingleComponent,
    CompaniesBulkComponent,
    IngredientsBulkComponent,
    AdminlistComponent,
    AdminlistAddEditComponent,
    IngredientsExportComponent,
    PointReplacerPipe
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    FormsModule,
    CurrencyMaskModule,
    AppRoutingModule,
    SelectModule,
    SimpleNotificationsModule.forRoot(),
    RecaptchaModule.forRoot(),
  ],
  providers: [
    FirebaseService,
    IngredientService,
    CategoryService,
    FirebaseStorageService,
    TonalityService,
    ColorShadeService,
    PigmentService,
    UserService,
    NewsService,
    CompanyService,
    ImageService,
    DocumentService,
    QuotationHistoryService,
    PaginationService,
    NotificationsService,
    HomeService,
    AuthGuard
   ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/app.module.ts